import { PURGE } from "redux-persist";

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface AuthState {
  refreshToken?: string | null;
  accessToken?: string | null;
  hasLoggedIn?: boolean;
}

export const authInitialState: AuthState = {
  refreshToken: null,
  accessToken: null,
  hasLoggedIn: false
};

const authSlice = createSlice({
  name: "auth",
  initialState: authInitialState,
  reducers: {
    setAuth: (state, action: PayloadAction<AuthState>) => {
      return {
        ...state,
        ...action.payload
      };
    },
    resetAuth: () => authInitialState
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, () => authInitialState);
  }
});

export const { setAuth, resetAuth } = authSlice.actions;
export const authReducer = authSlice.reducer;
